/* eslint-disable jsx-a11y/anchor-is-valid */
import { toAbsoluteUrl } from '@ospace/shared'
import { Notifications } from '@mantine/notifications'
import React, { useEffect } from 'react'

export const AuthLayout: React.FC = ({ children }) => {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`,
      }}
    >
      <Notifications />
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo */}
        <a href='#' className='mb-12'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/oSpace.svg')} className='h-45px' />
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>{children}</div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className='d-flex flex-center flex-column-auto p-10'>
        <div className='d-flex align-items-center fw-bold fs-6'>
          <a
            href='https://nextgen.group/ospace'
            target='_blank'
            className='text-muted text-hover-primary px-2'
            rel='noreferrer'
          >
            About Us
          </a>

          <a
            href='https://nextgen.group/contact-us'
            target='_blank'
            className='text-muted text-hover-primary px-2'
            rel='noreferrer'
          >
            Contact Us
          </a>
        </div>
      </div>
      {/* end::Footer */}
    </div>
  )
}
